<template>
	<a class="link" :href="url" @click.prevent="go">Feature request</a>
</template>

<script>
export default {
	data() {
		return {
			url:
				"https://docs.google.com/forms/d/e/1FAIpQLScjZlXG3rc3pSb3AP87lCs6GGmEZqLLob6MfZY2nBVjCQSj9Q/viewform?usp=sf_link"
		};
	},
	methods: {
		go() {
			goatevent({
				path: location.host + `-hero-feedback`,
				title: `hero feedback`,
				event: true
			});
			window.open(this.url, "_blank");
		}
	}
};
</script>

<style lang="scss" scoped>
.link {
	font-size: 0.55em;
	font-weight: 600;
	margin: 1em;
	color: $grey1;
	text-transform: uppercase;
	transition: color $aniTime $aniTiming;

	&:hover {
		color: $grey2;
	}

	@include mobile {
		display: none;
	}
}
</style>
